import { Tag } from "antd";
import React from "react";

const styles = {
  container: {},
};

interface Props {
  operations: Record<string, number>;
}
const Operations = (props: Props) => {
  const { operations } = props;
  return (
    <div style={styles.container}>
      {Object.keys(operations)
        .sort((a, b) => a.localeCompare(b))
        .map((operation) => (
          <Tag key={operation}>
            {operations[operation]} {operation}
          </Tag>
        ))}
    </div>
  );
};
export default Operations;
